import React, { useEffect, useState } from 'react';
import './OdCatCollection.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getClickCategory } from '../../../../actionCreators/home';
import OdButton from '../../OdButton/OdButton';

const OdCatCollection = ({ data, type = '', device = 'desktop' }) => {
  const { title, description, categories, cta, ctaLink } = data;
  const clickCategoryData = useSelector(state => state.home?.clickCategory);
  const [clickCategory, setClickCategory] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (clickCategory && clickCategoryData.data && clickCategoryData.data.urlPath) {
      window.location.href = `/sg/en/${clickCategoryData.data.urlPath}`;
    }
  }, [clickCategory, clickCategoryData]);

  const handleShapeClick = catId => {
    setClickCategory(true);
    dispatch(getClickCategory(catId));
  };

  return (
    <div className="odCatCollection">
      <h3 className="odCatCollection__title">{title}</h3>
      <p className="odCatCollection__description">{description}</p>
      <div className={`${type} odCatCollection__cards`}>
        {categories?.length > 0 &&
          categories?.map(cat => (
            <div key={cat?.title}>
              <div className="odCatCollection__card" onClick={() => handleShapeClick(cat?.catId)}>
                <img alt={cat?.title} className="odCatCollection__cardImg" src={cat?.imgSrc} />
                {device === 'desktop' ? (
                  <h4 className="odCatCollection__cardTitle">{cat?.title}</h4>
                ) : null}
              </div>
              {device === 'mobile' ? (
                <h4 className="odCatCollection__mobileTitle">{cat?.title}</h4>
              ) : null}
            </div>
          ))}
      </div>
      <div className="odCatCollection__cta">
        <OdButton href={ctaLink} label={cta} />
      </div>
      {device === 'mobile' ? <div className="odCatCollection__mobileBorder" /> : null}
    </div>
  );
};

export default OdCatCollection;
